// @flow

const flexConfig = {
  checkbox: {
    grow: 0,
    shrink: 0,
    width: 25,
    unit: 'px',
    align: 'left',
  },

  title: {
    grow: 1,
    shrink: 0,
    width: 200,
    unit: 'px',
    align: 'left',
  },
  sku: {
    grow: 0,
    shrink: 0,
    width: 90,
    unit: 'px',
    align: 'left',
  },

  amount: {
    grow: 0,
    shrink: 0,
    width: 80,
    unit: 'px',
    align: 'center',
  },

  listing: {
    grow: 0,
    shrink: 0,
    width: 60,
    unit: 'px',
    align: 'center',
  },

  picture: {
    grow: 0,
    shrink: 0,
    width: 40,
    unit: 'px',
    align: 'center',
  },

  shipping: {
    grow: 0,
    shrink: 0,
    width: 110,
    unit: 'px',
    align: 'right',
  },
};

export const flex = (
  key: $Keys<typeof flexConfig>
): {| align: 'left' | 'right' | 'center', flex: string |} => {
  const { grow, shrink, width, unit, align } = flexConfig[key];
  return { flex: `${grow} ${shrink} ${width}${unit}`, align };
};

type Option = {
  key: $Keys<typeof flexConfig>,
  times: number,
};

// works only for config 0 0 Npx
export const flexMany = (...options: Array<Option>): string => {
  const total = options.reduce(
    (acc, option) => acc + option.times * flexConfig[option.key].width,
    0
  );
  return `0 0 ${total}px`;
};
